import React from 'react'
import Spinner from '../Spinner'
import { withModifiers } from '../../helpers/withModifiers'
import styles from './styles.module.scss'

const STEP_ORDER = ['calculating', 'payment', 'reservation', 'confirmation']

const DEFAULT_MESSAGES = {
  calculating: 'Calculating price...',
  payment: 'Processing payment...',
  reservation: 'Creating reservation...',
  confirmation: 'Sending confirmation...'
}

const getStepStatus = (stepName, currentStep) => {
  if (!currentStep || !STEP_ORDER.includes(currentStep)) {
    return 'pending'
  }

  const stepIndex = STEP_ORDER.indexOf(stepName)
  const currentIndex = STEP_ORDER.indexOf(currentStep)

  if (stepIndex < currentIndex) {
    return 'completed'
  } else if (stepIndex === currentIndex) {
    return 'active'
  }
  return 'pending'
}

const ProgressIndicator = ({ currentStep = null, message, variant = [] }) => {
  const displayMessage = message || DEFAULT_MESSAGES[currentStep] || ''
  const shouldShowSpinner =
    currentStep !== null && STEP_ORDER.includes(currentStep)

  // Calculate step progress for screen readers
  const currentStepIndex = STEP_ORDER.indexOf(currentStep)
  const stepProgress =
    currentStepIndex >= 0
      ? `Step ${currentStepIndex + 1} of ${STEP_ORDER.length}`
      : ''

  return (
    <div
      className={withModifiers('progressIndicator', variant, styles)}
      role="status"
      aria-live="polite"
      aria-label={displayMessage}
    >
      {/* Screen reader announcement for step progress */}
      {stepProgress && (
        <span className={styles.srOnly}>
          {stepProgress}: {displayMessage}
        </span>
      )}

      {shouldShowSpinner && (
        <div className={styles.progressIndicator__spinner}>
          <Spinner variant={['darker']} />
        </div>
      )}

      {displayMessage && (
        <div className={styles.progressIndicator__message} aria-hidden="true">
          {displayMessage}
        </div>
      )}

      <div className={styles.progressIndicator__steps}>
        {STEP_ORDER.map((step) => {
          const status = getStepStatus(step, currentStep)
          return (
            <div
              key={step}
              className={`${styles.progressIndicator__step} ${
                styles[`progressIndicator__step--${status}`]
              }`}
              data-step={step}
              data-step-status={status}
            >
              <div className={styles.progressIndicator__stepDot} />
              {status === 'completed' && (
                <svg
                  className={styles.progressIndicator__stepCheck}
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M1 4.5L4.5 8L11 1"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProgressIndicator
